export const DB = './php/'                             //for production web server
//export const DB = '../455_vs/'                //for local web server
//export const DB = 'http://127.0.0.1/455_vs/src/php/' //for local dev

// export const HELP = "./../../static/Руководство пользователя.pdf"
export const HELP = "./static/Руководство пользователя - v5.pdf"

export const ROWS_ON_PAGE = 100


// WEBPACK FOOTER //
// ./src/constants/constants.js